/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRestAdapter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10.357 7.194A4.974 4.974 0 0 1 15 4a5 5 0 0 1 4.996 4.802 6.027 6.027 0 0 1 2.2 2.197L20.466 12a4.016 4.016 0 0 0-1.899-1.681l-.673-.288.07-.73.016-.132.006-.044A4.875 4.875 0 0 0 18 9a3 3 0 0 0-3-3 2.988 2.988 0 0 0-2.964 2.684l-.165 1.556-1.343-.804A2.956 2.956 0 0 0 9 9a3 3 0 0 0-3 3v1.535l-.445.297c-1.236.824-1.885 2.08-2.222 3.205-.105.35-.177.678-.226.963H8v2H1c0-1.627-.017-.352.001-1.07l.006-.157a10.325 10.325 0 0 1 .41-2.31C1.793 15.208 2.535 13.648 4 12.49V12a5 5 0 0 1 5-5c.474 0 .929.07 1.357.194zM16.5 15a2.5 2.5 0 0 0 0 5H18v-5zm3.5 2v1h2v2h-2v2h-3.5a4.502 4.502 0 0 1-4.388-3.5H10v-2h2.111A4.502 4.502 0 0 1 16.5 13H20v2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRestAdapter as RestAdapter };
